import React, { ReactNode, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSize } from "ahooks";
import "./layoutPage.scss";
import styled from "styled-components";
import { Layout } from "antd";
import { getSize } from "../../modules/helpers";
import { RootState, AppDispatch } from "../../store";
import { setSize } from "../../slices/storeSlice";
import {BasicTarget} from "ahooks/lib/utils/domTarget";

interface Props {
    children?: ReactNode;
}

function LayoutPage({ children, ...props }: Props) {
    const dispatch: AppDispatch = useDispatch();
    const lang: any = useSelector((state: RootState) => state.storeSlice.lang);
    const sizeStore: any = useSelector(
        (state: RootState) => state.storeSlice.size
    );

    const size = useSize(document.querySelector("body") as BasicTarget);

    useEffect(() => {
    }, []);

    useEffect(() => {
        if (size && size.width) {
            let currentSize = getSize(size.width);
            if (sizeStore !== currentSize) {
                dispatch(setSize(currentSize));
            }
        }
    }, [size, sizeStore]);

    return (
        <>
            <div className="layout">{children}</div>
        </>
    );
}

export default LayoutPage;
